import client from '../../../../apollo';
import { gql } from '@apollo/client'

export const MARKET_INDEX_FETCH_FAIL = 'DB_MARKET_INDEX_FETCH_FAIL';
export const MARKET_INDEX_FETCH_INIT = 'DB_MARKET_INDEX_FETCH_INIT';
export const MARKET_INDEX_FETCH_SUCCESS = 'DB_MARKET_INDEX_FETCH_SUCCESS';

const initialState = {
  data: {},
  error: '',
  loading: false
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case MARKET_INDEX_FETCH_FAIL:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    case MARKET_INDEX_FETCH_INIT:
      return {
        ...state,
        loading: true
      };
    case MARKET_INDEX_FETCH_SUCCESS:
      return {
        ...state,
        data: action.data,
        loading: false
      };
    default:
      return state;
  }
}

const marketIndexQuery = gql`
  query marketIndex {
    statistics {
      employeeDataEffectiveDate
      employeesPricedSlotted
      marketIndex {
        base
        totalCash
      }
    }
  }
`;

export const actions = {};

actions.getMarketIndex = async function getMarketIndex(dispatch) {
  dispatch({ type: MARKET_INDEX_FETCH_INIT });
  try {
    const response = await client.query({
      query: marketIndexQuery,
      fetchPolicy: 'network-only'
    });
    dispatch({
      type: MARKET_INDEX_FETCH_SUCCESS,
      data: response.data.statistics
    });
  } catch (error) {
    dispatch({
      type: MARKET_INDEX_FETCH_FAIL,
      error: error.message
    });
    console.log(error);
  }
};
